module.exports = __webpack_public_path__ + "static/media/trash_can.8ff7b67f.svg";